import Typography from "typography"
import funstonTheme from "typography-theme-funston"

funstonTheme.baseFontSize = '18px' // was 20px.
const typography = new Typography(funstonTheme)

export const { scale, rhythm, options } = typography
export default typography